export default __webpack_public_path__ + "static/media/calendar.9b2d4f5b.svg";